<button class="lang-button" mat-button type="button" [matMenuTriggerFor]="langMenu"
  [matTooltip]="i18n.t('language.change')" matTooltipPosition="below">
  <span class="lang-code">{{ current.short }}</span>
  <span class="lang-caret">▾</span>
</button>

<mat-menu #langMenu="matMenu">
  @for (language of languages; track language.code) {
    <button mat-menu-item type="button" (click)="select(language.code)">
      <span class="lang-item" [class.lang-item-active]="language.code === i18n.lang">
        {{ language.name }}
      </span>
    </button>
  }
</mat-menu>
